<template>
  <v-row no-gutters>
    <!-- 注释列表 -->
    <v-col cols="12">
      <v-card outlined>
        <v-card-title>注释列表
          <v-spacer />
          <v-btn color="primary" text @click="onDownloadDetail">下载</v-btn>
        </v-card-title>
      </v-card>
    </v-col>

    <!-- 统计绘图列表 -->
    <v-col cols="12">
      <v-card outlined>
        <!-- <v-card-title>统计绘图列表</v-card-title> -->
        <v-card-text style="overflow: auto;">
          <data-table :config="tableOption" :matrix="dataSource" ref="dataTable"></data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- 点击行单元格内容显示对话框 -->
    <v-dialog v-model="c2Visible" max-width="320" scrollable>
      <v-card max-height="450">
        <v-card-title>列表[{{c2Content.length}}]</v-card-title>
        <v-card-text class="pl-12">
          <p v-for="(c2,index) in c2Content" :key="index">{{c2}}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { userFileStream } from '@/plugins/api';
import DataTable from '@/views/Component/DataTable.vue';

export default {
  props: ['dataSourceParam', 'dataSource'],
  data () {
    return { c2Visible: false, c2Content: [] }
  },
  components: { DataTable },
  computed: {
    tableOption () {
      let ret = { cols: [], props: { 'checkbox-config': { checkAll: true } } }, r0 = (this.dataSource && this.dataSource.length) ? this.dataSource[0] : [], cols = [0, 1];
      for (let i = 0; i < r0.length; i++) {
        let col = { field: i, visible: cols.indexOf(i) != -1 };
        if (i == 0) {
          col.type = 'html';
          col.formatter = ({ cellValue }) => `<a>${cellValue}</a>`
        }
        ret.cols.push(col)
      }
      ret.events = { 'checkbox-change': this.updateChartData, 'checkbox-all': this.updateChartData, 'cell-click': this.onCellClick }
      ret.tools = [{ name: '下载', color: 'primary', text: true, click: this.onDownloadOutput }];
      return ret;
    }
  },
  methods: {
    // =============== 勾选绘图表格
    updateChartData () {
      let xTable = this.$refs.dataTable.$refs.xTable;
      let srs = xTable.getCheckboxRecords();
      this.$emit('change', srs);
    },
    onCellClick ({ row, columnIndex }) {
      if (columnIndex == 1) {
        this.c2Content = row[2].split(';') || [];
        this.c2Visible = true;
      }
    },
    // =============== 文件下载
    onDownloadOutput () { // 下载绘图数据
      let dto = this.Utility.clone(this.dataSourceParam);
      dto.toolTask.resultFile = 'Loc2proteins.txt';
      userFileStream(dto);
    },
    onDownloadDetail () { // 下载匹配结果详细数据
      let dto = this.Utility.clone(this.dataSourceParam);
      dto.toolTask.resultFile = 'protein2Loc.txt';
      userFileStream(dto);
    }
  }
}
</script>